module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview",
    on: {
      "click": _vm.selectText
    }
  }, [_c('div', {
    staticClass: "meta"
  }, [_c('h2', {
    staticClass: "name meta-text"
  }, [_vm._v(_vm._s(_vm.fontName) + " by " + _vm._s(_vm.fontAuthor))]), _vm._v(" "), (_vm.wasRecentlyClicked) ? _c('div', {
    staticClass: "copied-msg meta-text"
  }, [_vm._v("Copied to clipboard")]) : _c('div', {
    staticClass: "click-msg meta-text"
  }, [_vm._v("Click to copy")])]), _vm._v(" "), (_vm.loaded) ? _c('pre', {
    ref: "text",
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.generatedText))]) : _c('spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50a8a359!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = 33
// module chunks = 0